import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { CompanySelectionDescriptionDTO } from '@iota/iota-management-portal-v4-client';

@Component({
    standalone: false,
    selector: 'app-selection-description',
    templateUrl: './selection-description.component.html',
    styleUrls: ['./selection-description.component.scss']
})
export class SelectionDescriptionComponent implements OnInit, OnChanges {
    @Input() selectionDescription: CompanySelectionDescriptionDTO;

    @Output() deleted = new EventEmitter<CompanySelectionDescriptionDTO>();

    editMode = false;
    markedAsDeleted = false;

    selectionDescriptionForm = new FormGroup({
        selectionKey: new FormControl('', Validators.required),
        name: new FormControl('', Validators.required),
        comment: new FormControl('')
    });

    ngOnInit(): void {
        this.updateFormValues();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes?.selectionDescription?.currentValue) {
            this.updateFormValues();
        }
    }

    updateFormValues() {
        if (this.selectionDescription?.companySelectionDescriptionId) {
            this.selectionDescriptionForm.patchValue({
                selectionKey: this.selectionDescription.selectionKey,
                name: this.selectionDescription.name,
                comment: this.selectionDescription.comment
            });
            this.selectionDescriptionForm.markAsPristine();
            this.selectionDescriptionForm.disable();
        } else {
            this.editMode = true;
            this.selectionDescriptionForm.markAsPristine();
            this.selectionDescriptionForm.enable();
        }
    }

    edit() {
        this.editMode = true;
        this.selectionDescriptionForm.enable();
    }

    saveEdit() {
        if (this.selectionDescriptionForm?.valid) {
            this.editMode = false;
            this.selectionDescriptionForm?.disable();
        }
    }

    getUpdatedSelectionDescription(): CompanySelectionDescriptionDTO {
        if (!this.markedAsDeleted && (this.selectionDescriptionForm.dirty || !this.selectionDescription.companySelectionDescriptionId)) {
            const formValues = this.selectionDescriptionForm.value;

            return {
                ...this.selectionDescription,
                ...formValues
            };
        }

        return null;
    }

    getDeletedSelectionDescriptionIds(): string {
        if (this.markedAsDeleted && this.selectionDescription?.companySelectionDescriptionId) {
            return this.selectionDescription?.companySelectionDescriptionId;
        }

        return null;
    }

    markAsDeleted() {
        this.markedAsDeleted = true;

        if (!this.selectionDescription?.companySelectionDescriptionId) {
            this.deleted.emit(this.selectionDescription);
        }
    }

    undoDelete() {
        this.markedAsDeleted = false;
    }
}
